import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action} from 'mobx';
import Slide from '@material-ui/core/Slide';
import Close from 'react-icons/lib/io/close';
import SvgIconButton from '../../../components/SvgIconButton';
import {black, typoDark, white} from '../../../themes/colors';
import {isMobile} from '../../../utils/screenUtility';
import DialogWrapper from '../../../components/dialog/Dialog';
import LatencyTest from '../../main/latencyTest';
import './uploadTrack.scss';
import BpmCalculator from '../../main/bpmCalculator';
import {normalizeBpm} from '../../../utils/audioUtility';
import {RecorderDialogState} from "../../../constants/enums";

const iconButtonStyle = {
    width: 24,
    minWidth: 24,
    height: 24,
    minHeight: 24,
    color: black
};

@inject('looperStore', 'uploadTrackStore', 'wizardStore', 'recorderStore')
@observer
class BaseTrackDialogContainer extends Component {
    @action onCalculateBpm = (bpm) => {
        const normalized = normalizeBpm(bpm);
        this.props.uploadTrackStore.setBpm(normalized);
    };

    handleClose = () => {
        if(this.props.showLatencyTest) return null;
        this.props.handleDialogClose();
    };

    renderDefaultTopRightButton = () => {
        const {showBpmCalculator, isCloseButtonHidden, showLatencyTest} = this.props;
        if (showBpmCalculator || isCloseButtonHidden || showLatencyTest){
            return null;
        }
        return (
            <SvgIconButton containerClass={`dialog-close ${(isMobile() && this.props.showLatencyTest) ? 'latency' : ''}`} rippleColor={white} style={iconButtonStyle} onClick={this.handleClose}>
                <Close style={{fill: typoDark, fontSize: 14}}/>
            </SvgIconButton>
        );
    };

    render() {
        const {
            renderForm, renderTopRightButton, enabledMicrophone, showLatencyTest, showBpmCalculator, toggleBpm,
            handlePlay, handleStop, showDialog, dialogMode, onLatencyDone, looperStore, wizardStore,
        } = this.props;
        const {recorderState} = this.props.recorderStore
        const classNames = {
            root: `upload-modal-root ${recorderState} ${dialogMode} ${looperStore.isStudentAssignment ? 'is-read-only' : ''} ${wizardStore.fullScreenMode ? 'fullscreen-active' : ''}`,
            scrollPaper: 'scroll-paper',
            paper: 'paper'
        }
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            BackdropProps: {classes: {root: 'overlay'}},
            disableEscapeKeyDown: true,
            TransitionProps: {direction: 'up'},
            classes: classNames,
            onClose: this.handleClose,
            open: showDialog
        };
        const isRecordingFlow = dialogMode === RecorderDialogState.Record;
        return showDialog && (
            <DialogWrapper {...dialogProps}>
                <div className={`upload-track-container ${enabledMicrophone ? '' : 'no-microphone'}`}>
                    {renderTopRightButton ? renderTopRightButton() : this.renderDefaultTopRightButton()}
                    {!showLatencyTest && renderForm()}
                    {showBpmCalculator && <BpmCalculator
                        play={handlePlay}
                        stop={handleStop}
                        toggleBpm={toggleBpm}
                        isRecordingFlow={isRecordingFlow}
                        onCalculateBpm={this.onCalculateBpm}/>
                    }
                    {showLatencyTest && <LatencyTest onStartTest={this.onStartLatencyTest} onLatencyDone={onLatencyDone} source={'b'}/>}
                </div>
            </DialogWrapper>
        );
    }
}

export default BaseTrackDialogContainer;
